import { useEffect, useState, useRef } from "react";
import axios from "axios";
import swal from "sweetalert";
import "./game.css";
import { useForm } from "react-hook-form";
import CloseIcon from "@mui/icons-material/Close";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";

function Fishing() {
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
    const [isLoading, setLoading] = useState(false);
    const [game, setGame] = useState(null);
    const [title, setTitle] = useState(null);
    const [isShow, setShow] = useState(false);
  const canvasRef = useRef(null);

  useEffect(() => {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
      let width = (canvas.width = window.innerWidth);
      let height = (canvas.height = window.innerHeight);
      const particleCount = 100;
      const particles = [];
      const g = 10;
      const img = new Image();
      img.src = "/images/bubble.png";

      function init() {
          for (let i = 0; i < particleCount; i++) {
              createParticle();
          }
      }

      function createParticle() {
          const newParticle = new Particle();
          newParticle.initialize();
          particles.push(newParticle);
      }

      function Particle() {
          this.initialize = function () {
              this.x = Math.random() * width;
              this.y = Math.random() * height + height;
              this.v = 5 + Math.random() * 5;
              this.s = 5 + Math.random() * 40;
          };

          this.update = function () {
              this.x += Math.sin(this.s);
              this.s -= 0.1;
              if (this.s < 0) {
                  this.s = 0;
              }
              this.y -= this.v * 0.35;
              if (this.isOutOfBounds()) {
                  this.initialize();
              }
          };

          this.draw = function () {
              ctx.drawImage(img, this.x, this.y, this.s, this.s);
          };

          this.isOutOfBounds = function () {
              return this.x < 0 || this.x > width || this.y < 0 || this.y > height;
          };
      }

      function render() {
          ctx.clearRect(0, 0, width, height);
          for (let i = 0; i < particles.length; i++) {
              particles[i].update();
              particles[i].draw();
          }
          requestAnimationFrame(render);
      }

      function resize() {
          width = canvas.width = window.innerWidth;
          height = canvas.height = window.innerHeight;
      }

      window.addEventListener("resize", resize);

      init();
      render();

      // Cleanup function
      return () => {
          window.removeEventListener("resize", resize);
      };
  }, []);
    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile != res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
    }, []);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {}).then((res) => {
            setProfile(res.data.data);
            localStorage.setItem("profile", JSON.stringify(res.data.data));
        });
    }, []);
    function launchGame(params) {
        if (profile === null) {
            navigate("/login");
            return false;
        }
        if (isLoading == true) return false;
        const form = {
            ...params,
            platform: "WEB"
        };
        setLoading(true);
        axios
            .post(`${process.env.REACT_APP_API_URL}/callback/v1/api/seamless/launch`, form)
            .then((res) => {
                if (res.data.data.url && res.data.data.url != "") {
                    window.location.href = res.data.data.url;
                } else {
                    swal("Sảnh đang bảo trì", "Vui lòng chọn sảnh khác", "error");
                }
                setLoading(false);
            })
            .catch((err) => {
                swal("Đã có lỗi xảy ra", err.response.data.message != "internal server error" ? err.response.data.message : "Vui lòng đăng xuất và đăng nhập lại", "error");
                setLoading(false);
            });
    }
    const navigate = useNavigate();
    const [profile, setProfile] = useState(null);
    const [playGame, setPlayGame] = useState(null);
    const { register, handleSubmit } = useForm();
    const [newMoney, setNewMoney] = useState(null);
    const [balance, setBalance] = useState(0);
    const [sanh, setSanh] = useState(null);
    const [product, setProduct] = useState(null);
    const [type, setType] = useState(null);
    const [load, setLoad] = useState(false);

    const menuGame = (params) => {
        setTitle(title);
        setLoading(true);
        axios
            .post(`${process.env.REACT_APP_API_URL}/callback/v1/api/seamless/getlist`, params)
            .then((res) => {
                if (res.data.data.provider_games.length == 0) {
                    swal("Thông báo", "Sảnh game bảo trì", "error");
                    setLoading(false);
                } else {
                    setGame(res.data.data.provider_games);
                    setLoading(false);
                    setShow(true);
                }
            })
            .catch((err) => {
                swal("Thông báo", "Sảnh game bảo trì", "error");
                setLoading(false);
            });
    };
    return (
        <>
            <Header profile={profile} />
            {isLoading == true ? (
                <div className="loading">
                    <div className="loader"></div>
                </div>
            ) : null}
            <div className="bg-fishing">
                <div className="container">
                    <center>
                        <img src={require("../../image/common/title4.png")} />
                    </center>
                    <div className="box-fishing">
                        {/*<div className="fishing-play" onClick={() => menuGame("Bắn cá", "140", "FISH")}>
                            <img src={require("../../image/common/fish_jilifish_main.png")} />
                        </div>
                        <div className="fishing-play" onClick={() => menuGame("Bắn cá", "43", "FISH")}>
                            <img src={require("../../image/common/fish_mgfish_main.png")} />
                        </div>*/}
                        <div></div>
                        <div className="fishing-play" onClick={() => menuGame({ product_code: "1009", game_type: "FISHING" })}>
                            <img src={require("../../image/common/fish_cq9fish_main.png")} />
                        </div>
                        <div className="fishing-play" onClick={() => menuGame({ product_code: "1085", game_type: "FISHING" })}>
                            <img src={require("../../image/common/fish_jdbfish_main.png")} />
                        </div>
                    </div>
                </div>
                <canvas ref={canvasRef} id="bubble" />
            </div>
            {isShow === true ? (
                <>
                    <div className="popup-backdrop">
                        <div className="popup-main">
                            <div className="popup-header">{title}</div>
                            <div className="popup-content">
                                <div className="gameapi-list">
                                    {game != null &&
                                        game.map((item) => (
                                            <>
                                                {item.status == "ACTIVATED" && (
                                                    <div
                                                        className="gameapi-item"
                                                        onClick={() => launchGame({ product_code: item.product_code, game_type: item.game_type, game_code: item.game_code })}>
                                                        <img src={`${item.image_url}`} alt={item.game_name} />
                                                        <div className="gameapi-name">{item.game_name}</div>
                                                    </div>
                                                )}
                                            </>
                                        ))}
                                </div>
                            </div>
                            <button onClick={() => setShow(false)} className="popup-close">
                                Đóng
                            </button>
                        </div>
                    </div>
                </>
            ) : null}
        </>
    );
}
export default Fishing;
